import React, { useEffect, useState } from 'react'
import { useKeycloak } from 'react-keycloak'
import { Icons } from '@fabricks/ui-components'
import { MetricCardElement } from '../../../components/DashboardItems/MertricCardElement'
import { MaterialStatDto, StatisticDto, useGetMaterialStatsForInvalidMaterialMetricQuery, } from '../../../api/models'
import { getContext } from '../../../services/apiService'
import { transformIconColor, useMetricStatus } from "../../../services/metricCardService";
import Navigation from "../../../constants/navigation";
import { useHistory } from "react-router-dom";

export const InvalidMaterialMetricCard: React.FC<any> = () => {
    const [keycloak] = useKeycloak()
    const history = useHistory()
    const [metricStatus, setMetricStatus] = useMetricStatus()
    const [statData, setStatData] = useState<MaterialStatDto>({})
    const { data, loading, error } = useGetMaterialStatsForInvalidMaterialMetricQuery({ context: getContext(keycloak.token) })

    useEffect(() => {
        if (data && data.getStatistics) {
            setStatData((data.getStatistics as StatisticDto).materialStat as MaterialStatDto)
        }

        if (statData.invalid != null && statData.invalid > 0) {
            setMetricStatus({
                status: 'error',
                message: `${((statData.invalid / (statData.all || 0)) * 100).toFixed(
                    2
                )}% invalid material data sets`,
            })
            return () => {}
        }

        if (error) {
            setMetricStatus({ status: 'error', message: error.message })
        }
        return () => {}
    }, [data, error, statData])

    const ofValue = statData.all || 0
    const value = (statData.all || 0) - (statData.invalid || 0)

    const handleOnMetricStatus = () => {
        if (metricStatus.status === 'error') {
            return history.push(`/masterdata/materials?filter=isInvalid`)
        }
        return history.push(`${Navigation.Materials.path}`)
    }

    return (
        <MetricCardElement
            initLoadingTime={1500}
            isLoading={loading}
            title="Valid Materials"
            ofValue={ofValue}
            value={value}
            onClickMetricStatus={handleOnMetricStatus}
            statusType={metricStatus.status}
            statusMessage={metricStatus.message}
            iconColor={transformIconColor(metricStatus)}
            icon={<Icons.Receipt />}
        />
    )
}
